<div class="border-0 px-4 py-1 scroll-container" ref="RiskQuestions">
  <NavigationBackButton/>
  <div class="card-header card-header-primary card-nav-tabs border shadow rounded-lg mt-3">
      <div class="nav-tabs-navigation">
        <div class="nav-tabs-wrapper">
          <ul class="nav nav-tabs" data-tabs="tabs">
            <li class=" border rounded-lg me-2 nav-item" v-for="(tab, index) in tabs" :key="index"
              :class="[ active_tab === tab ? 'active' : 'inactive' ]" @click="set_active_tab(tab)">
              <a class="text-white text-decoration-none text-xs nav-link" href="#profile" data-toggle="tab">
                {{ tab }}
              </a>
            </li>
          </ul>
          <hr class="text-white"/>
        </div>
      </div>
    </div>
  <div class="card rounded-lg border-0 shadow mt-2">
    <div class="card-body rounded-lg">
        <!-- Checklist Weightings Tab -->
        <div v-if="active_tab === 'Checklist Weightings'">
          <div
            v-for="(question, qIndex) in checklist_weight_questions"
            :key="question.id"
            class="card p-3 mb-3 shadow border table-border-color rounded-lg"
          >
            <p class="fw-bold mb-2 text-xs">{{ question.question }}</p>
            <div v-for="(choice, cIndex) in question.choices" :key="cIndex" class="row align-items-center mb-2 g-1">
              <div class="col-3">
                <label class="text-xxs mb-0">{{ choice.option }}</label>
              </div>
              <div class="col-auto">
                <input
                  type="number"
                  class="form-control text-xxs rounded-sm shadow form-control-sm"
                  v-model.number="choice.weight"
                  min="0"
                />
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <button
              class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
              :disabled="!can_save_checklist_weights"
              @click="save_checklist_weights"
            >
              Save Risk Weights
            </button>
          </div>
        </div>

        <!-- Question Assignments Tab -->
        <div v-if="active_tab === 'Question Assignments'">
          <div class="p-3 rounded-5 mt-3">
            <div class=" rounded-lg p-3 table-responsive text-xs">
              <table
                class="table table-bordered table-striped table-sm"
                id="question_management_table"
              >
                <thead class="custom-header">
                  <tr>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">NO.</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Question</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Type</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Choices</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in table_safe_question_list" :key="row.id">
                    <td class="text-xxs text-start">{{ index + 1 }}</td>
                    <td class="text-xxs text-start">{{ row.question }}</td>
                    <td class="text-xxs text-start">{{ row.type }}</td>
                    <td class="text-xxs text-start">{{ row.choices }}</td>
                    <td>
                      <input
                        type="checkbox"
                        :checked="selected_questions.includes(row.id)"
                        @change="toggle_selection(row.id)"
                        class="form-check-input border border-dark"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="d-flex justify-content-end mt-3">
                <button
                  class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                  @click="assign_selected_questions_to_assessment"
                >
                  Assign Selected to Risk Assessment
                </button>
              </div>
            </div>

          </div>
        </div>



      <!-- Risk Categories Tab -->
       <div class="risk-categories-scroll-container">
        <div v-if="active_tab === 'Risk Categories'">
          <div v-for="(category, index) in risk_categories" :key="index" class="card p-3 mb-3 shadow border table-border-color rounded-lg">
            <div class="d-flex justify-content-between align-items-start">
              <div class="w-100">
                <!-- Risk Level and Score Range -->
                <div class="d-flex align-items-center gap-3 mb-2">
                  <template v-if="!category.is_new">
                    <span
                      class="badge rounded-pill text-dark">
                      {{ category.risk_level }} Risk
                    </span>
                  </template>
                  <template v-else>
                  
                    <input
                      v-model="category.risk_level"
                      placeholder="Risk Level"
                      class="form-control text-xxs rounded-sm shadow form-control-sm w-50"
                    />
                  </template>

                  <label class="text-xs fw-bold mb-0 ms-auto">Score Range :</label>
                  <input
                    type="number"
                    v-model.number="category.min_value"
                    placeholder="Min"
                    class="form-control text-xxs rounded-sm shadow form-control-sm w-auto"
                  />
                  <span>-</span>
                  <input
                    type="number"
                    v-model.number="category.max_value"
                    placeholder="Max"
                    class="form-control text-xxs rounded-sm shadow form-control-sm w-auto"
                  />
                </div>

                <!-- Auto Decision -->
                <div class="mb-2">
                  <label class="text-xs fw-bold mb-1 mt-2">Auto Decision</label>
                  <input
                    v-model="category.auto_decision"
                    placeholder="e.g., approve, reject, escalate"
                    class="form-control text-xxs rounded-sm shadow form-control-sm w-50"
                  />
                </div>

                <!-- Color Picker -->
                <div class=" form-group mb-2">
                  <label class=" form_label text-xs fw-bold mb-1 mt-2">Color Code</label>
                  <input
                    type="color"
                    v-model="category.color_code"
                    class="color-input form-control form-control-sm p-0 shadow"
                  />
                </div>
              </div>

              <button
                v-if="category.is_new"
                @click="remove_risk_category(index)"
                class="btn btn-sm btn-primary-dark text-white ms-2"
                title="Remove unsaved category"
              >
                <i class="bi bi-trash btn-primary-dark"></i>
              </button>
            </div>
          </div>

          <button class="btn btn-primary-dark btn-sm mt-2 rounded-small text-xxs shadow text-dark" @click="add_risk_category">
            + Add Risk Level
          </button>

          <div class="mt-3 text-end">
            <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="save_risk_categories">
              Save Risk Categories
            </button>
          </div>
        </div>
       </div>
    </div>
  </div>
</div>